import { ModalCustom } from "components/ModalCustom";
import { ContainerForm } from "./style";
import { Col, Form, Row } from "react-bootstrap";
import { DropdownSelect } from "components/DropdownSelect";
import temaPadrao from "_config/temas/estilo/base";
import { CustomInput } from "components/CustomInput";
import { IPlanilhaCriarLote } from "../../../../interfaces/IPlanilhaCriarLote";

interface IProps {
  show: boolean;
  dados: IPlanilhaCriarLote;
  setDados: (dados: IPlanilhaCriarLote) => void;
  onConfirm: () => void;
  handleClose: () => void;
}

export function ModalEditarVeiculo({
  show,
  dados,
  handleClose,
  onConfirm,
  setDados,
}: IProps) {
  const validarVeiculo = () => {
    const regexRenavam = /^[0-9]{11}$/;
    const regexChassi = /^[A-HJ-NPR-Z0-9]{17}$/i;
    const regexPlacaAntiga = /^[A-Z]{3}[0-9]{4}$/;
    const regexPlacaMercosul = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;
    const UFS_VALIDAS = ["PR"];

    if (
      !regexPlacaAntiga.test(dados.placa) &&
      !regexPlacaMercosul.test(dados.placa)
    ) {
      return false;
    }

    if (!regexRenavam.test(dados.renavam)) {
      return false;
    }

    if (!regexChassi.test(dados.chassi)) {
      return false;
    }

    if (!UFS_VALIDAS.includes(dados.uf.toUpperCase())) {
      return false;
    }
    return true;
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Editar veículo"
      centered
      footer
      footerConfirmButton
      confirmButtonText="Salvar alterações"
      onConfirm={onConfirm}
      disabledConfirmButton={
        !dados.placa ||
        !dados.chassi ||
        !dados.renavam ||
        !dados.uf ||
        !validarVeiculo()
      }
      size="lg"
    >
      <ContainerForm>
        <Row style={{ marginBottom: 18 }}>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                Placa
              </Form.Label>
              <CustomInput
                title=""
                value={dados.placa}
                onChange={(event) => {
                  setDados({ ...dados, placa: event.target.value ?? "" });
                }}
                placeholder="Placa"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                Chassi
              </Form.Label>
              <CustomInput
                title=""
                value={dados.chassi}
                onChange={(event) => {
                  setDados({ ...dados, chassi: event.target.value ?? "" });
                }}
                placeholder="Chassi"
              />
            </Form.Group>
          </Col>
        </Row>
        <Row style={{ marginBottom: 18 }}>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                Renavam
              </Form.Label>
              <CustomInput
                title=""
                value={dados.renavam}
                onChange={(event) => {
                  setDados({ ...dados, renavam: event.target.value ?? "" });
                }}
                placeholder="Renavam"
                disabled
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label
                style={{ color: temaPadrao.colors.neutral.neutral70 }}
              >
                UF
              </Form.Label>
              <DropdownSelect
                options={[{ value: "PR", label: "PR" }]}
                title=""
                selectedValue={dados.uf}
                onSelect={(value) => {
                  setDados({ ...dados, uf: value ?? "" });
                }}
                searchable
              />
            </Form.Group>
          </Col>
        </Row>
      </ContainerForm>
    </ModalCustom>
  );
}
